import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useHistory, useLocation } from 'react-router-dom'
import Header from '../Component/Header'
import PageHead from '../Component/pageHead'
import Footer from '../Component/footer'
import { PostAction } from '../Component/PostAction'
import {
  loginPath,
  needsPasswordChange,
  safeReturnPath,
  setMustChangePassword,
} from '../utils/sessionAuth'

function ChangePassword() {
  const history = useHistory()
  const location = useLocation()
  const returnUrl = safeReturnPath(new URLSearchParams(location.search).get('returnUrl'))
  const forced = needsPasswordChange()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!sessionStorage.getItem('id')) {
      history.replace(loginPath(returnUrl))
    }
  }, [history, returnUrl])

  const onSubmit = async (e) => {
    e.preventDefault()
    setError('')
    if (!currentPassword) {
      setError('Please enter your current password.')
      return
    }
    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters.')
      return
    }
    if (newPassword !== confirmPassword) {
      setError('New password and confirm password do not match.')
      return
    }
    if (newPassword === currentPassword) {
      setError('New password must be different from the current password.')
      return
    }

    setSaving(true)
    try {
      const res = await PostAction(
        'post',
        {
          id: sessionStorage.getItem('id'),
          current_password: currentPassword,
          new_password: newPassword,
        },
        'user/changePassword'
      )
      if (res?.status !== 'success') {
        setError(res?.message || 'Could not update the password.')
        return
      }
      setMustChangePassword(false)
      history.replace(returnUrl || '/')
    } finally {
      setSaving(false)
    }
  }

  return (
    <>
      <Header />
      <PageHead title="Change password" />
      <div className="container" style={{ fontSize: 20, minHeight: '615px' }}>
        <div className="card mx-auto" style={{ maxWidth: 520 }}>
          <div className="card-body">
            {forced ? (
              <p className="mb-3" style={{ fontSize: 16 }}>
                You signed in with a temporary password. Please choose a new password to
                continue.
              </p>
            ) : (
              <p className="mb-3" style={{ fontSize: 16 }}>
                Choose a new password for your account.
              </p>
            )}
            {error ? (
              <div className="alert alert-danger" style={{ fontSize: 16 }} role="alert">
                {error}
              </div>
            ) : null}
            <Form onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label" htmlFor="current-password">
                  {forced ? 'Temporary password' : 'Current password'}
                </label>
                <input
                  id="current-password"
                  className="form-control"
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  autoComplete="current-password"
                />
              </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="new-password">
                  New password
                </label>
                <input
                  id="new-password"
                  className="form-control"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  autoComplete="new-password"
                />
              </div>
              <div className="mb-3">
                <label className="form-label" htmlFor="confirm-password">
                  Confirm new password
                </label>
                <input
                  id="confirm-password"
                  className="form-control"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  autoComplete="new-password"
                />
              </div>
              <div className="text-center">
                <button className="btn btn-primary" type="submit" disabled={saving}>
                  {saving ? 'Saving…' : 'Update password'}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default ChangePassword
